<template lang="pug">
#lista-laudo-operacao
    BaseHeader(
        titulo='Fiscalização Operação',
        icon='el-icon-download',
        btnTexto='Exportar dados',
        :exibeBotao='true',
        @btnHeaderClicado='exportarDados'
    )

    section.lista-laudo-operacao__filtros
        .pesquisa-inteligente__container
            .pesquisa-inteligente__barra-pesquisa
                i.el-icon-search
                input.lista-laudo-operacao__barra-pesquisa__input(
                    v-model='payloadFiltro.textoBusca',
                    type='text',
                    :placeholder='gerarPlaceholderPesquisaInteligente()',
                    autocomplete='off',
                    @keyup.enter='buscarFiscalizacoesOperacoes(0)'
                )

        .filtros-lista-laudo-operacao__button
            el-popover(placement='bottom', width='500', trigger='click')
                el-button.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) Filtros Avançados

                el-form.filtro(label-position='top')
                    .filtros-lista-laudo-operacao-popover-header
                        .filtros-lista-laudo-operacao-popover-header__text Filtros avançados
                        .filtros-lista-laudo-operacao-popover-header__link(
                            @click='aplicar'
                        )
                            | Aplicar filtro

                    .filtros-lista-laudo-operacao-popover-collapse
                        el-form-item.mb-0.filtro-accordion
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(title='Status', name='status')
                                    .el-collapse-item__status--loading(
                                        v-loading='!status.length'
                                    )
                                        el-checkbox-group(
                                            :max='1',
                                            v-model='statusSelecionado'
                                        )
                                            el-checkbox(
                                                v-for='(s, index) in status',
                                                :label='s',
                                                :key='index'
                                            )
                                                | {{ s.nome }}

                                el-collapse-item(
                                    title='Situação',
                                    name='situacao'
                                )
                                    .el-collapse-item__situacao--loading(
                                        v-loading='!situacao.length'
                                    )
                                        el-checkbox-group(
                                            :max='1',
                                            v-model='situacaoSelecionada'
                                        )
                                            el-checkbox(
                                                v-for='(s, index) in situacao',
                                                :label='s',
                                                :key='index'
                                            )
                                                | {{ s.nome }}

                                el-collapse-item(title='Datas', name='datas')
                                    el-form-item(label='Data solicitação')
                                        el-date-picker(
                                            v-model='dataSolicitacao',
                                            type='daterange',
                                            range-separator='-',
                                            format='dd-MM-yyyy',
                                            start-placeholder='Data de início',
                                            end-placeholder='Data do fim'
                                        )
                                    el-form-item(label='Previsão de entrega')
                                        el-date-picker(
                                            v-model='dataPrevisaoEntrega',
                                            type='daterange',
                                            range-separator='-',
                                            format='dd-MM-yyyy',
                                            start-placeholder='Data de início',
                                            end-placeholder='Data do fim'
                                        )
                                    el-form-item(label='Data entrega')
                                        el-date-picker(
                                            v-model='dataEntrega',
                                            type='daterange',
                                            range-separator='-',
                                            format='dd-MM-yyyy',
                                            start-placeholder='Data de início',
                                            end-placeholder='Data do fim'
                                        )

    section.lista-laudo-operacao__filtro-selecionado
        span.lista-laudo-operacao__filtro-selecionado__titulo Filtros selecionados:
        el-tag.lista-laudo-operacao__filtro-selecionado__tag(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ tag.nome }}

        el-tag.lista-laudo-operacao__filtro-selecionado__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) Limpar filtros
            i.el-icon-delete

        span.lista-laudo-operacao__filtro-selecionado__nenhum(v-else) Nenhum filtro selecionado

    section.lista-laudo-operacao__tabela
        el-table(:key="listagemTableKey('fiscalizacao-op', laudosOperacao, paginacao.pagina + 1)", :data='laudosOperacao', stripe, height='calc(100% - 54px)')
            el-table-column(
                v-if='verificaPerfilAnalista()',
                label='ID do laudo',
                align='center'
            )
                template(slot-scope='scope')
                    span {{ scope.row.id ? scope.row.id : '--' }}

            el-table-column(
                v-if='verificaPerfilAnalista()',
                label='Usuário solicitante',
                align='center'
            )
                template(slot-scope='scope')
                    span {{ scope.row.usuarioSolicitante ? scope.row.usuarioSolicitante : '--' }}

            el-table-column(
                v-if='verificaPerfilAnalista()',
                label='Analista responsável',
                align='center'
            )
                template(slot-scope='scope')
                    span {{ scope.row.analista ? scope.row.analista : '--' }}

            el-table-column(
                v-if='verificaPerfilAnalista()',
                label='Empresa',
                align='center'
            )
                template(slot-scope='scope')
                    span {{ scope.row.empresa ? scope.row.empresa : '--' }}

            el-table-column(label='Identificador', align='center')
                template(slot-scope='scope')
                    span {{ scope.row.identificador ? scope.row.identificador : '--' }}

            el-table-column(label='Beneficiário', align='center')
                template(slot-scope='scope')
                    span {{ scope.row.beneficiario ? scope.row.beneficiario : '--' }}

            el-table-column(label='Data solicitação', align='center')
                template(slot-scope='scope')
                    span {{ scope.row.dataSolicitacao ? scope.row.dataSolicitacao : '--' }}

            el-table-column(label='Previsão de entrega', align='center')
                template(slot-scope='scope')
                    span {{ scope.row.dataPrevisaoEntrega ? scope.row.dataPrevisaoEntrega : '--' }}

            el-table-column(label='Data entrega', align='center')
                template(slot-scope='scope')
                    span {{ scope.row.dataEntrega ? scope.row.dataEntrega : '--' }}

            el-table-column(label='Situação', align='center')
                template(slot-scope='scope')
                    span {{ scope.row.situacao ? scope.row.situacao : '--' }}

            el-table-column(label='Status', align='center')
                template(slot-scope='scope')
                    span {{ scope.row.status ? scope.row.status : '--' }}

            el-table-column(label='Ações', width='100', align='center')
                template(slot-scope='scope')
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                v-for='(acoes, index) in scope.row.acoesDisponiveis',
                                :key='index',
                                :icon='fiscalizacaoOperacaoAcoes[acoes].icone',
                                @click.native='fiscalizacaoOperacaoAcoes[acoes].callback(scope.row)'
                            ) {{ fiscalizacaoOperacaoAcoes[acoes].nome }}

        .tabela-rodape
            .tabela-rodape--esquerda
                p {{ paginacao.total }} fiscalizações

            .tabela-rodape--pagination
                el-pagination(
                    small,
                    layout='prev, pager, next',
                    :page-size='paginacao.itensPorPagina',
                    :current-page.sync='paginacao.pagina',
                    :total='paginacao.total',
                    @current-change='buscarFiscalizacoesOperacoes(paginacao.pagina - 1)'
                )

        ModalInsercaoResultado(
            :laudo='laudo',
            :show.sync='mostrarModalResultado',
            @atualizarListagem='buscarFiscalizacoesOperacoes(0)'
        )

    ModalVisualizacao(:show.sync='showModalVisualizacao', :idLaudo='idLaudo')
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import ModalInsercaoResultado from '@/views/operacao/fiscalizacao/ModalInsercaoResultado';
import OperacaoLaudoService from '@/services/OperacaoLaudoService';
import ModalVisualizacao from '@/components/fiscalizacaoOperacao/ModalVisualizacao';

export default {
    name: 'ListaFiscalizacaoOperacoes',
    components: {
        BaseHeader,
        ModalInsercaoResultado,
        ModalVisualizacao
    },
    data() {
        return {
            showModalVisualizacao: false,
            laudosOperacao: [],
            tags: [],
            collapseFiltroAvancado: [''],
            status: [],
            situacao: [],
            statusSelecionado: [],
            situacaoSelecionada: [],
            acaoCollapse: {
                status: {
                    collapse: 'status',
                    callback: 'buscarStatus'
                },
                situacao: {
                    collapse: 'situacao',
                    callback: 'buscarSituacao'
                }
            },
            dataSolicitacao: null,
            dataEntrega: null,
            dataPrevisaoEntrega: null,
            payloadFiltro: {
                textoBusca: null,
                filtrosAvancados: {
                    solicitacaoInicio: null,
                    solicitacaoFim: null,
                    entregaInicio: null,
                    entregaFim: null,
                    previsaoEntregaInicio: null,
                    previsaoEntregaFim: null,
                    situacao: [],
                    status: []
                },
                paginacao: { pagina: 0, itensPorPagina: 20, direcao: 'ASC' }
            },
            paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            },
            mostrarModalResultado: false,
            idLaudo: null,
            laudo: {},
            fiscalizacaoOperacaoAcoes: {
                BAIXAR_RESULTADO: {
                    nome: 'Baixar resultado',
                    codigo: 'BAIXAR_RESULTADO',
                    icone: 'el-icon-download',
                    callback: this.baixarResultado
                },
                BAIXAR_SHAPE: {
                    nome: 'Baixar shape',
                    codigo: 'BAIXAR_SHAPE',
                    icone: 'el-icon-download',
                    callback: this.baixarShape
                },
                ENVIAR_RESULTADO: {
                    nome: 'Enviar resultado',
                    codigo: 'CANCELAR',
                    icone: 'el-icon-circle-close',
                    callback: this.enviarResultado
                },
                VISUALIZAR: {
                    nome: 'Visualizar',
                    codigo: 'VISUALIZAR',
                    icone: 'el-icon-view',
                    callback: this.visualizarFiscalizacaoOperacao
                }
            }
        };
    },
    async mounted() {
        this.verificaPerfilAnalista();
        await this.buscarFiscalizacoesOperacoes(0);
    },
    methods: {
        gerarPlaceholderPesquisaInteligente() {
            if (this.verificaPerfilAnalista()) {
                return 'Pesquisa inteligente (Busque por Identificador da operação, Beneficiário ou Empresa solicitante)';
            } else {
                return 'Pesquisa inteligente (Busque por Identificador da operação ou Beneficiário)';
            }
        },
        verificaPerfilAnalista() {
            return this.$store.state.usuarioLogado.isAnalyst;
        },
        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);

            this.desmarcarFiltroPopover(filtro);

            this.aplicar();
        },
        desmarcarFiltroPopover(filtro) {
            switch (filtro.tipo) {
                case 'DATA_ENTREGA':
                    this.dataEntrega = null;
                    this.payloadFiltro.filtrosAvancados.entregaInicio = null;
                    this.payloadFiltro.filtrosAvancados.entregaFim = null;
                    break;
                case 'DATA_PREVISAO_ENTREGA':
                    this.dataPrevisaoEntrega = null;
                    this.payloadFiltro.filtrosAvancados.previsaoEntregaInicio =
                        null;
                    this.payloadFiltro.filtrosAvancados.previsaoEntregaFim =
                        null;
                    break;
                case 'DATA_SOLICITACAO':
                    this.dataSolicitacao = null;
                    this.payloadFiltro.filtrosAvancados.solicitacaoInicio =
                        null;
                    this.payloadFiltro.filtrosAvancados.solicitacaoFim = null;
                    break;
                case 'STATUS':
                    this.statusSelecionado = [];
                    this.payloadFiltro.filtrosAvancados.status = [];
                    break;
                case 'SITUACAO':
                    this.situacaoSelecionada = [];
                    this.payloadFiltro.filtrosAvancados.situacao = [];
                    break;
            }
        },
        limparFiltros() {
            [...this.tags].forEach(tag => this.removerFiltro(tag));
        },
        aplicar() {
            this.atualizarFiltroAvancado();
            this.tags = [
                ...this.statusSelecionado,
                ...this.situacaoSelecionada
            ];

            if (this.dataEntrega) {
                this.tags.push({
                    id: 1,
                    nome: `Data entrega: de ${this.dataEntrega[0].toLocaleDateString(
                        'pt-BR'
                    )} a ${this.dataEntrega[1].toLocaleDateString('pt-BR')}`,
                    codigo: 'DATA_ENTREGA',
                    tipo: 'DATA_ENTREGA'
                });
            }

            if (this.dataPrevisaoEntrega) {
                this.tags.push({
                    id: 1,
                    nome: `Data previsão de entrega: de ${this.dataPrevisaoEntrega[0].toLocaleDateString(
                        'pt-BR'
                    )} a ${this.dataPrevisaoEntrega[1].toLocaleDateString(
                        'pt-BR'
                    )}`,
                    codigo: 'DATA_PREVISAO_ENTREGA',
                    tipo: 'DATA_PREVISAO_ENTREGA'
                });
            }

            if (this.dataSolicitacao) {
                this.tags.push({
                    id: 1,
                    nome: `Data solicitação: de ${this.dataSolicitacao[0].toLocaleDateString(
                        'pt-BR'
                    )} a ${this.dataSolicitacao[1].toLocaleDateString(
                        'pt-BR'
                    )}`,
                    codigo: 'DATA_SOLICITACAO',
                    tipo: 'DATA_SOLICITACAO'
                });
            }

            this.tags.sort((a, b) => a.nome.localeCompare(b.nome));
            this.buscarFiscalizacoesOperacoes(0);
        },
        atualizarFiltroAvancado() {
            if (this.situacaoSelecionada.length > 0) {
                this.payloadFiltro.filtrosAvancados.situacao = [
                    this.situacaoSelecionada[0].codigo
                ];
            } else {
                this.payloadFiltro.filtrosAvancados.situacao = [];
            }

            if (this.statusSelecionado.length > 0) {
                this.payloadFiltro.filtrosAvancados.status = [
                    this.statusSelecionado[0].codigo
                ];
            } else {
                this.payloadFiltro.filtrosAvancados.status = [];
            }

            if (this.dataEntrega) {
                this.payloadFiltro.filtrosAvancados.entregaInicio =
                    this.dataEntrega[0];
                this.payloadFiltro.filtrosAvancados.entregaFim =
                    this.dataEntrega[1];
            } else {
                this.payloadFiltro.filtrosAvancados.entregaInicio = null;
                this.payloadFiltro.filtrosAvancados.entregaFim = null;
            }

            if (this.dataPrevisaoEntrega) {
                this.payloadFiltro.filtrosAvancados.previsaoEntregaInicio =
                    this.dataPrevisaoEntrega[0];
                this.payloadFiltro.filtrosAvancados.previsaoEntregaFim =
                    this.dataPrevisaoEntrega[1];
            } else {
                this.payloadFiltro.filtrosAvancados.previsaoEntregaInicio =
                    null;
                this.payloadFiltro.filtrosAvancados.previsaoEntregaFim = null;
            }

            if (this.dataSolicitacao) {
                this.payloadFiltro.filtrosAvancados.solicitacaoInicio =
                    this.dataSolicitacao[0];
                this.payloadFiltro.filtrosAvancados.solicitacaoFim =
                    this.dataSolicitacao[1];
            } else {
                this.payloadFiltro.filtrosAvancados.solicitacaoInicio = null;
                this.payloadFiltro.filtrosAvancados.solicitacaoFim = null;
            }
        },
        abrirCollapse(ref) {
            if (ref && ref !== 'datas') {
                try {
                    const acao = this.acaoCollapse[ref];
                    if (!this[ref].length) {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados.'
                    );
                }
            }
        },
        buscarStatus() {
            this.status = [
                { id: 1, nome: 'Conforme', codigo: 'CONFORME', tipo: 'STATUS' },
                {
                    id: 2,
                    nome: 'Inconforme',
                    codigo: 'INCONFORME',
                    tipo: 'STATUS'
                }
            ];
        },
        buscarSituacao() {
            this.situacao = [
                {
                    id: 1,
                    nome: 'Processado',
                    codigo: 'PROCESSADO',
                    tipo: 'SITUACAO'
                },
                {
                    id: 2,
                    nome: 'Em processamento',
                    codigo: 'EM_PROCESSAMENTO',
                    tipo: 'SITUACAO'
                }
            ];
        },
        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },
        async buscarFiscalizacoesOperacoes(pagina) {
            this.payloadFiltro.paginacao.pagina = pagina;
            this.payloadFiltro.paginacao.itensPorPagina =
                this.paginacao.itensPorPagina;
            this.payloadFiltro.paginacao.direcao = this.paginacao.direcao;

            await OperacaoLaudoService.buscar(this.payloadFiltro)
                .then(({ data }) => {
                    this.laudosOperacao = data.itens;
                    this.paginacao = data.paginacao;
                    this.paginacao.pagina += 1;
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Erro ao buscar fiscalizações da operações.'
                    });
                });
        },

        async baixarResultado(laudo) {
            try {
                await OperacaoLaudoService.downloadResultado(laudo.id);

                this.$notify.success({
                    message: 'Download realizado com sucesso!'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao realizar download.'
                });
            }
        },

        async baixarShape(laudo) {
            try {
                await OperacaoLaudoService.gerarShapeFile(laudo.id);
                await this.buscarFiscalizacoesOperacoes(0);

                this.$notify.success({
                    message: 'Arquivo exportado com sucesso!'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao exportar o arquivo.'
                });
            }
        },

        async exportarDados() {
            try {
                await OperacaoLaudoService.gerarExcel();

                this.$notify.success({
                    message: 'Download realizado com sucesso!'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao realizar download.'
                });
            }
        },

        enviarResultado(laudo) {
            this.laudo = laudo;
            this.mostrarModalResultado = true;
        },

        visualizarFiscalizacaoOperacao(laudo) {
            this.idLaudo = laudo.id;
            this.showModalVisualizacao = true;
        }
    }
};
</script>

<style lang="scss">
#lista-laudo-operacao {
    height: 100%;
    width: 100%;

    .lista-laudo-operacao__tabela {
        margin: 0 20px;
        border-radius: 5px;
        height: calc(100vh - 304px);
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .el-table {
            border-radius: 5px;
            height: calc(100% - 54px);
            width: 100%;
        }

        .el-table th {
            font-weight: bold;
            font-size: 14px;
        }

        .tabela-btn {
            margin-top: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            margin-top: 8px;
            border-radius: 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }
    }

    .lista-laudo-operacao__filtros {
        display: flex;
        justify-content: space-between;
        margin: 20px 20px;

        .pesquisa-inteligente__container {
            width: 100%;
            height: 42px;
            border-radius: 5px;
            background: var(--white);
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
            position: relative;
            margin-right: 10px;

            .pesquisa-inteligente__barra-pesquisa {
                height: 100%;
                display: flex;
                justify-content: center;

                i.el-icon-search {
                    color: var(--primary);
                    font-size: 25px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    margin: 0 8px;
                }

                .lista-laudo-operacao__barra-pesquisa__input {
                    width: 100%;
                    height: 100%;
                    border: none;
                    outline: none;
                    border-radius: 5px;
                    color: var(--primary);
                }
            }
        }
    }
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    .lyra-filtro:before {
        content: '';
        width: 15px !important;
        height: 12px !important;
        background-color: var(--primary) !important;
        margin-right: 6px;
    }
}

.filtros-lista-laudo-operacao-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtros-lista-laudo-operacao-popover-header__text {
        color: var(--primary);
        font-weight: 600;
    }

    .filtros-lista-laudo-operacao-popover-header__link {
        color: #1989fa;
        text-decoration: underline;
        cursor: pointer;
    }
}

.filtros-lista-laudo-operacao-popover-collapse {
    .el-select {
        width: 100%;
    }
    .el-collapse-item__header {
        font-weight: 500;
    }
    .filtro-accordion {
        margin-top: 10px;
    }
    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 200px;
        line-height: 2;
    }
    .el-checkbox-group,
    .el-radio-group {
        display: flex;
        flex-wrap: wrap;
    }
}

.filtros-lista-laudo-operacao-popover-collapse__select {
    display: flex;
    justify-content: space-between;
}

.filtros-lista-laudo-operacao-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 200px;
        line-height: 2;
    }

    .el-checkbox-group,
    .el-radio-group {
        display: flex;
        flex-wrap: wrap;
    }
}

.el-collapse-item__status--loading {
    min-height: 30px;
}

.el-collapse-item__situacao--loading {
    min-height: 30px;
}

.filtros-lista-laudo-operacao-popover-collapse__select {
    display: flex;
    justify-content: space-between;
}

.lista-laudo-operacao__filtro-selecionado {
    margin: 20px 0 0 20px;
    min-height: 42px;
}

.lista-laudo-operacao__filtro-selecionado__titulo {
    font-size: 18px;
    font-weight: 100;
    margin-right: 10px;
}

.lista-laudo-operacao__filtro-selecionado__tag {
    margin: 0 5px 10px 5px;
}

.lista-laudo-operacao__filtro-selecionado__limpar {
    cursor: pointer;
    margin: 0 5px 10px 5px;

    i {
        padding-left: 5px;
    }
}

.lista-laudo-operacao__filtro-selecionado__nenhum {
    margin-left: 5px;
    font-weight: 100;
    font-style: italic;
    font-size: 14px;
}
</style>
